import { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../api/client';
import { logger } from './logger';

const errText = (e) => e?.response?.data?.detail || e?.message || 'Hata';

/** 🤖 Otomatik bot: durum (15 sn'de bir) + aksiyonlar. */
export function useAutoTrade() {
    const [status, setStatus] = useState(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        try {
            const { data } = await apiClient.get('/autotrade/status');
            setStatus(data);
        } catch (e) {
            logger.warn('autotrade status failed', e);
        }
    }, []);

    const act = useCallback(async (fn) => {
        setBusy(true);
        setError(null);
        try {
            const r = await fn();
            await load();
            return r;
        } catch (e) {
            setError(errText(e));
            throw e;
        } finally {
            setBusy(false);
        }
    }, [load]);

    const start = useCallback((mode) => act(() => apiClient.post('/autotrade/start', { mode })), [act]);
    const stop = useCallback((closeAll, mode) => act(() => apiClient.post('/autotrade/stop', { close_all: !!closeAll, mode: mode || null })), [act]);
    const save = useCallback((patch) => act(() => apiClient.put('/autotrade/settings', patch)), [act]);
    const closePos = useCallback((id) => act(() => apiClient.post(`/autotrade/positions/${id}/close`)), [act]);
    const resetPaper = useCallback(() => act(() => apiClient.post('/autotrade/paper/reset')), [act]);
    const reconcileReal = useCallback(() => act(() => apiClient.post('/autotrade/real/reconcile')), [act]);

    useEffect(() => {
        load();
        const id = setInterval(load, 15000);
        return () => clearInterval(id);
    }, [load]);

    return { status, busy, error, setError, reload: load, start, stop, save, closePos, resetPaper, reconcileReal };
}
